export default __webpack_public_path__ + "static/media/sort-down.0fe67b53.svg";